export default {
  goal: 'Développer votre patrimoine',
  label: {
    loanCapacity: "Votre capacité d'emprunt",
    precautionarySavings: 'Votre épargne disponible',
    savingsCapacity: "Votre capacité d'épargne mensuelle",
  },
}
